import authBaseAxios from "../utils/api";
import { IModulePermissionsResponse, IRolesResponse, IBodyRoleDto, IRoleDetailResponse } from "../interfaces/role";

export const RoleServices = {
  getAll: (params?: any): Promise<IRolesResponse> => {
    return authBaseAxios.get("roles", params);
  },

  createRole: (body: IBodyRoleDto): Promise<IRoleDetailResponse> => {
    return authBaseAxios.post("roles", body);
  },

  updateRole: (id: string, body: IBodyRoleDto): Promise<IRoleDetailResponse> => {
    return authBaseAxios.put(`roles/${id}`, body);
  },

  deleteRole: (id: string) => {
    return authBaseAxios.delete(`roles/${id}`);
  },

  getModulePermissions: (): Promise<IModulePermissionsResponse> => {
    return authBaseAxios.get("permissions/modules");
  },
};
